// utils/formatMessengerTime.js
import moment from "moment";

export const formatMessengerTime = (timestamp) => {
    const now = moment();
    const messageTime = moment(timestamp);
    // const diffSeconds = now.diff(messageTime, 'seconds');
    const diffMinutes = now.diff(messageTime, 'minutes');
    const diffHours = now.diff(messageTime, 'hours');

    // if (diffSeconds < 60) return `${diffSeconds}s`;
    if (diffMinutes < 60) return `${diffMinutes}m`;
    if (diffHours < 24) return `${diffHours}h`;
    return messageTime.format("hh:mm A"); 
};
